export default function pageTransition() {
  $.expr[':'].internal = function (obj, index, meta, stack) {
    // Prepare
    var $this = $(obj),
      url = $this.attr('href') || '',
      isInternalLink;

    // Check link
    isInternalLink = url.substring(0, wordpress.homeurl.length) === wordpress.homeurl || url.indexOf(':') === -1;

    // Ignore or Keep
    return isInternalLink;
  };

  $(document).on(
    'click',
    'a:internal:not(.no-ajaxy, .no-ajaxify,[target="_blank"],[href^="#"],[href$=".pdf"],[href*="wp-login"],[href*="wp-admin"])',
    function (e) {
      e.preventDefault();
      const url = $(this).attr('href');

      $('body').fadeOut(250, function () {
        document.location.href = url;
      });
    }
  );
}
